import { useQuery } from "hooks";
import { getSearch } from "../utils";

export const useRouteSearch = () => {
  const { query } = useQuery({ exclude: ["infoWindowPoint"] });
  const search = getSearch({ query });
  return search;
};
